import * as BaseTypes from '../../base/types';
import { history } from '../../history';
import * as AuthenticationOperations from './operations';
import * as AuthenticationTypes from './types';

const AuthenticationMiddleware = ({ dispatch, getState }) => (next) => (action) => {
    if (typeof action === 'function') {
        return action(dispatch, getState);
    }
    if (action && action.type === AuthenticationTypes.LOG_OUT) {
        history.push('/login');
    }

    if (action && action.type === BaseTypes.APP_ESSENTIAL_RELOAD) {
        const res = next(action);

        dispatch(AuthenticationOperations.refreshAuthentication()).catch((err) => err);

        return res;
    }

    return next(action);
};

export { AuthenticationMiddleware };
